// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"ff005440","453":"32a2bd80"}[chunkId] + ".chunk.js";
};